"use strict";
/**
 * Public API for the retirement calculation engine. Pure TypeScript,
 * no DOM / DB / network dependencies. Safe for SSR and unit tests.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.runRetirementCalculation = exports.BLANK_ON_FIRST_LOAD_FIELDS = exports.DEFAULT_INPUTS = exports.BLANK_INPUTS = exports.BASE_CASE = exports.RETURN_INPUT_WARNING_ABOVE_PCT = exports.RETURN_INPUT_MAX_PCT = exports.highReturnAssumptionWarning = exports.validateInputs = exports.SCENARIO_ORDER = exports.runScenarios = exports.solveGap = exports.initialAnnualisedWithdrawalIndicator = exports.firstMonthlyLifestyleExpense = exports.projectWithdrawal = exports.calculateRequiredCorpus = exports.unitStepUpSipFutureValueFactor = exports.projectAccumulation = exports.effectiveAnnualToMonthly = void 0;
__exportStar(require("./types"), exports);
var rates_1 = require("./rates");
Object.defineProperty(exports, "effectiveAnnualToMonthly", { enumerable: true, get: function () { return rates_1.effectiveAnnualToMonthly; } });
var accumulation_1 = require("./accumulation");
Object.defineProperty(exports, "projectAccumulation", { enumerable: true, get: function () { return accumulation_1.projectAccumulation; } });
Object.defineProperty(exports, "unitStepUpSipFutureValueFactor", { enumerable: true, get: function () { return accumulation_1.unitStepUpSipFutureValueFactor; } });
var withdrawal_1 = require("./withdrawal");
Object.defineProperty(exports, "calculateRequiredCorpus", { enumerable: true, get: function () { return withdrawal_1.calculateRequiredCorpus; } });
Object.defineProperty(exports, "projectWithdrawal", { enumerable: true, get: function () { return withdrawal_1.projectWithdrawal; } });
Object.defineProperty(exports, "firstMonthlyLifestyleExpense", { enumerable: true, get: function () { return withdrawal_1.firstMonthlyLifestyleExpense; } });
Object.defineProperty(exports, "initialAnnualisedWithdrawalIndicator", { enumerable: true, get: function () { return withdrawal_1.initialAnnualisedWithdrawalIndicator; } });
var gap_1 = require("./gap");
Object.defineProperty(exports, "solveGap", { enumerable: true, get: function () { return gap_1.solveGap; } });
var scenarios_1 = require("./scenarios");
Object.defineProperty(exports, "runScenarios", { enumerable: true, get: function () { return scenarios_1.runScenarios; } });
Object.defineProperty(exports, "SCENARIO_ORDER", { enumerable: true, get: function () { return scenarios_1.SCENARIO_ORDER; } });
var validate_1 = require("./validate");
Object.defineProperty(exports, "validateInputs", { enumerable: true, get: function () { return validate_1.validateInputs; } });
Object.defineProperty(exports, "highReturnAssumptionWarning", { enumerable: true, get: function () { return validate_1.highReturnAssumptionWarning; } });
Object.defineProperty(exports, "RETURN_INPUT_MAX_PCT", { enumerable: true, get: function () { return validate_1.RETURN_INPUT_MAX_PCT; } });
Object.defineProperty(exports, "RETURN_INPUT_WARNING_ABOVE_PCT", { enumerable: true, get: function () { return validate_1.RETURN_INPUT_WARNING_ABOVE_PCT; } });
var fixtures_1 = require("./fixtures");
Object.defineProperty(exports, "BASE_CASE", { enumerable: true, get: function () { return fixtures_1.BASE_CASE; } });
Object.defineProperty(exports, "BLANK_INPUTS", { enumerable: true, get: function () { return fixtures_1.BLANK_INPUTS; } });
Object.defineProperty(exports, "DEFAULT_INPUTS", { enumerable: true, get: function () { return fixtures_1.DEFAULT_INPUTS; } });
Object.defineProperty(exports, "BLANK_ON_FIRST_LOAD_FIELDS", { enumerable: true, get: function () { return fixtures_1.BLANK_ON_FIRST_LOAD_FIELDS; } });
const index_core_1 = require("./index-core");
const scenarios_2 = require("./scenarios");
const withdrawal_2 = require("./withdrawal");
/**
 * Full orchestrator. Given a validated CalculatorInputs bundle,
 * returns the deterministic result set used by the UI.
 */
function runRetirementCalculation(inputs) {
    const core = (0, index_core_1.runCoreCalculation)(inputs);
    const scenarios = (0, scenarios_2.runScenarios)(inputs);
    const indicator = (0, withdrawal_2.initialAnnualisedWithdrawalIndicator)(inputs, core.accumulation.projectedRetirementCorpus, core.required.firstMonthlyLifestyleExpense, core.required.firstMonthlyDependableIncome);
    return {
        inputs,
        accumulation: core.accumulation,
        withdrawal: core.withdrawal,
        required: core.required,
        gap: core.gap,
        scenarios,
        initialAnnualisedWithdrawalIndicator: indicator,
        alreadyRetired: core.gap.alreadyRetired,
    };
}
exports.runRetirementCalculation = runRetirementCalculation;
